export default {
  screens: [
    {
      type: 'intro',
      title: '황실의 정선',
      content:
        '비오 7세 교황에게 수여된 교황관은 쇼메와 조세핀의 만남에 특별한 가교 역할을 했습니다.',
      idYt: 'q7zuNJ10apM',
      videoCover: 'world/sovereign/video.jpg',
      desktop: {
        cover: 'world/sovereign/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sovereign/mobile-cover-1.jpg',
        contentStyle: { width: '70%' },
        coverStyle: {
          width: '110%',
          top: '90%',
          left: '15%',
          position: 'absolute'
        }
      },
      isBottom: true
    },
    {
      type: 'columnVideo',
      content:
        '나폴레옹이 선사했던 외교 선물 중에서도 가장 중요한 의미가 있는 이 비오 7세 교황의 교황관은 나폴레옹의 요청으로 제작되었으며, 1804년 12월 2일 파리 노트르담 성당에서 열렸던 대관식에 참석해 준 것에 대한 감사의 의미로 교황에게 전달되었습니다. ',
      idYt: 'O-1TKgKxDdg',
      videoCover: 'world/sovereign/video-2.jpg',
      cover: 'world/sovereign/cover-2.jpg',
      isBottom: true
    },
    {
      type: 'video',
      middleImg: 'world/sovereign/tiare.jpg',
      videoBlock: {
        cover: 'world/sovereign/video-3.jpg',
        idYt: '5ExHUFrxFms'
      },
      content:
        '바티칸은 이번 전시회를 계기로 쇼메에게 이 교황관의 복원과 교황관 위에 놓여 있는 에메랄드에 세팅될 새로운 십자가를 만들어 줄 것을 요청했습니다.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/sovereign.js